import { default as contactsvmO9gwdyLiMeta } from "/vercel/path0/pages/contacts.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93VAlSJbRo1dMeta } from "/vercel/path0/pages/services/[...slug].vue?macro=true";
import { default as indexkd184pULVkMeta } from "/vercel/path0/pages/services/index.vue?macro=true";
export default [
  {
    name: contactsvmO9gwdyLiMeta?.name ?? "contacts___ru",
    path: contactsvmO9gwdyLiMeta?.path ?? "/ru/contacts",
    meta: contactsvmO9gwdyLiMeta || {},
    alias: contactsvmO9gwdyLiMeta?.alias || [],
    redirect: contactsvmO9gwdyLiMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: contactsvmO9gwdyLiMeta?.name ?? "contacts___et",
    path: contactsvmO9gwdyLiMeta?.path ?? "/contacts",
    meta: contactsvmO9gwdyLiMeta || {},
    alias: contactsvmO9gwdyLiMeta?.alias || [],
    redirect: contactsvmO9gwdyLiMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___ru",
    path: indexe9Brt5DfdhMeta?.path ?? "/ru",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___et",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93VAlSJbRo1dMeta?.name ?? "services-slug___ru",
    path: _91_46_46_46slug_93VAlSJbRo1dMeta?.path ?? "/ru/services/:slug(.*)*",
    meta: _91_46_46_46slug_93VAlSJbRo1dMeta || {},
    alias: _91_46_46_46slug_93VAlSJbRo1dMeta?.alias || [],
    redirect: _91_46_46_46slug_93VAlSJbRo1dMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/services/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93VAlSJbRo1dMeta?.name ?? "services-slug___et",
    path: _91_46_46_46slug_93VAlSJbRo1dMeta?.path ?? "/services/:slug(.*)*",
    meta: _91_46_46_46slug_93VAlSJbRo1dMeta || {},
    alias: _91_46_46_46slug_93VAlSJbRo1dMeta?.alias || [],
    redirect: _91_46_46_46slug_93VAlSJbRo1dMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/services/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexkd184pULVkMeta?.name ?? "services___ru",
    path: indexkd184pULVkMeta?.path ?? "/ru/services",
    meta: indexkd184pULVkMeta || {},
    alias: indexkd184pULVkMeta?.alias || [],
    redirect: indexkd184pULVkMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexkd184pULVkMeta?.name ?? "services___et",
    path: indexkd184pULVkMeta?.path ?? "/services",
    meta: indexkd184pULVkMeta || {},
    alias: indexkd184pULVkMeta?.alias || [],
    redirect: indexkd184pULVkMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/services/index.vue").then(m => m.default || m)
  }
]